import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Text, Button } from '../../..'
import BotHead from '../../../shared/Avatar/BotHeadColored'

import styles from './RefiRateRequestPanel.module.scss'

const RefiRateRequestPanelFailure = ({ doSubmit }) => (
  <>
    <BotHead className={styles.botHead} quizzical type='error' />
    <Text size='xl' className={styles.title} variant='neutralCool' variantCount='900'>
      <FormattedMessage
        id='RefiRateRequestPanelFailure.title'
        defaultMessage='Communication with our server failed. Please try again shortly.'
      />
    </Text>
    <Button className={styles.backButton} onClick={doSubmit}>
      <FormattedMessage id='RefiRateRequestPanelFailure.button' defaultMessage='Back' />
    </Button>
  </>
)

RefiRateRequestPanelFailure.propTypes = {
  doSubmit: PropTypes.func.isRequired
}

export default RefiRateRequestPanelFailure
